//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class DynamicRuleProfileModel extends ModelBase {
      static readonly $typeName = 'DynamicRuleProfileModel';
      public key: string;
      public isActive: boolean;
      public isEnabled: boolean;
      public name: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/DynamicRuleProfileModel.ts